var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mag-submenu-groups"},_vm._l((_vm.magGroups),function(item){return _c('mag-submenu-item-group',{key:item.id,attrs:{"item":item,"groupItems":_vm.itemsByGroupId[item.id]}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }